import swal from 'sweetalert2'
import router from '../../router/router'
import { API } from '../../services'
import { resetStateToDefault, promiseTimeout } from '../../utils'

function defaultState () {
  return {
    pwd: ''
  }
}

const ___state = defaultState()

export default {
  namespaced: true,
  state: ___state,
  mutations: {
    pwd (state, pwd) {
      state.pwd = pwd
    },
    resetState (state) {
      resetStateToDefault(state, defaultState())
    }
  },
  actions: {
    async checkpwd ({ commit, dispatch, state, rootState }) {
      if (state.pwd.length < 3) {
        swal({ type: 'info', text: 'Digite uma senha válida' })
      } else {
        const checkPassword  = () => {
          return API.checkpwd.save({
            pwd: state.pwd,
            fingerprint: rootState.accessData.browserRecord.id
          })
        }

        let check = promiseTimeout(3000, checkPassword())

        check.then(result => {
          // SUCCESS
          let name = result.body.success.employee.name

          if (rootState.visualConfigs.visual.webEmployeeNickname) {
            name = result.body.success.employee.nickname
          }

          swal({
            type: 'question',
            text: 'Seu nome é ' + name + '?',
            showCancelButton: true,
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim'
          }).then((ans) => {
            if (ans.value) {
              commit('punchTimelog/todayPts', result.body.success.dayPts, {root: true})
              commit('punchTimelog/monthPts', result.body.success.pts, {root: true})
              commit('punchTimelog/recordVoice', result.body.success.employee.allowVoice, {root: true})
              commit('punchTimelog/forcarModalDeRequisicaoDeVoz', result.body.success.employee.forcarModalDeRequisicaoDeVoz, {root: true})
              commit('punchTimelog/doubleCheck', result.body.success.employee.doubleCheck, {root: true})
              commit('punchTimelog/omitirBotoesDePausaNoRegistro', result.body.success.employee.omitirBotoesDePausaNoRegistro, {root: true})
              commit('punchTimelog/employee', result.body.success.employee, {root: true})
              commit('punchTimelog/sessionToken', result.body.success.sessionToken, {root: true})
              commit('punchTimelog/fallback', false, {root: true})

              router.push({name: 'punchTimelog'})
            } else {
              router.push({name: 'password'})
            }
          })

          // Adiciona id no botão de Sim ao solicitar confirmação do nome
          document.querySelector('.swal2-confirm.swal2-styled').setAttribute('id', 'confirmanome')
        })

        check.catch(error => {
          // ERROS ESPERADOS

          if (error === 'timeout' || error.status === 0) {
            // PROCESSO DE FALLBACK PARA A SENHA

            let employee = null
            let has_pwd = false
            if (!rootState.accessData.browserRecord.personal) {
              if (rootState.accessData.browserRecord.fallback) {
                rootState.accessData.browserRecord.fallback.forEach((item) => {
                  if (item['pwd'] === state.pwd) {
                    employee = item
                    has_pwd = true
                  }
                })
              }
            }

            if (!employee && rootState.accessData.browserRecord.employee && rootState.accessData.browserRecord.employee.pwd === state.pwd) {
              employee = rootState.accessData.browserRecord.employee
              has_pwd = true
            }

            let question = ''

            if (has_pwd) {
              if (employee) {
                question = 'Seu nome é ' + employee.name + '?'
              } else {
                question = 'Você tem certeza que sua senha é ' + state.pwd + '?'
              }

              swal({
                type: 'question',
                text: question,
                showCancelButton: true,
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim'
              }).then((ans) => {
                if (ans.value) {
                  commit('punchTimelog/employee', employee, {root: true})
                  commit('punchTimelog/fallback', true, {root: true})

                  router.push({name: 'punchTimelog'})
                } else {
                  router.push({name: 'password'})
                }
              })
            } else {
              swal({
                type: 'warning',
                text: 'Senha inválida',
                allowOutsideClick: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.value) {
                  router.push({name: 'password'})
                }
              })
            }
          } else if (error.status === 429) {
            swal({type: 'error', text: 'Você atingiu o limite de tentativas permitido, tente novamente após 1 minuto.'})
          } else {
            // INFORMAÇÕES INVÁLIDAS

            if (error.body.error.browser_record && error.body.error.resig) {
              swal({
                type: 'warning',
                text: 'Você não tem mais permissão para registrar ponto.',
                allowOutsideClick: false,
                confirmButtonText: 'OK'
              })
            } else if (!error.body.error.browser_record) {
              swal({
                type: 'warning',
                text: 'Dispositivo descadastrado',
                allowOutsideClick: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.value) {
                  router.push({name: 'clear'})
                }
              })
            } else {
              swal({type: 'error', text: 'Senha Inválida'})
            }
          }
        })
      }
    },

    async startFirebaseMessaging ({ state, rootState }) {
      if (!rootState.accessData.browserRecord.personal) {
        return
      }

      await Notification.requestPermission()
        .then(function (permission) {
          if (permission === 'granted') {
            console.warn('Notification permission granted.')
          } else {
            console.warn('Unable to get permission to notify.')
          }
        })

      window.firebaseMessaging.getToken().then(async (currentToken) => {
        if (currentToken) {
          await API.userFirebaseToken.save(
            {employeeId: rootState.accessData.browserRecord.employee.id},
            {firebaseToken: currentToken}
          )
        } else {
          console.warn('No Instance ID token available. Request permission to generate one.')
        }
      }).catch(function (err) {
        console.error('An error occurred while retrieving token. ', err)
      })

      if (window.removeOnMessageCallabackFirebase) {
        window.removeOnMessageCallabackFirebase()
      }

      window.removeOnMessageCallabackFirebase = window.firebaseMessaging.onMessage(function (payload) {
        // console.log(payload.data.title, payload)
        new Notification('Notification title', {
          icon: payload.data.icon,
          ...payload.notification
        })
      })
    }
  }
}
